export const STORAGE_BUCKETS = {
  COUNSELOR_IMAGES: 'counselorpimages',
};

export const validateImageFile = (file: File) => {
  const maxSizeInBytes = 500 * 1024; // 500KB
  const allowedTypes = ['image/jpeg', 'image/png'];
  
  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error: 'Only JPEG and PNG images are allowed'
    };
  }
  
  if (file.size > maxSizeInBytes) {
    return {
      valid: false,
      error: `Image must be smaller than 500KB. Current size: ${(file.size / 1024).toFixed(2)}KB`
    };
  }
  
  return { valid: true };
};
